export const noWorldCup26Query = {
  bool: {
    must_not: {
      term: {
        eventDisplayName: 'World Cup 2026',
      },
    },
  },
};
